import { useAppLayoutHeaderAnchor } from '@components/AppLayout/AppLayoutContext'
import { Portal } from '@mui/material'
import ExtendedPageHeader from '@ui/ExtendedPageHeader'
import Skeleton from '@ui/Skeleton'
import { isNil } from 'lodash-es'
import type React from 'react'

import * as S from './styles'

export interface PageHeaderProps {
  inline?: boolean
  className?: string
  title?: React.ReactNode
  subtitle?: React.ReactNode
}

const PageHeader: React.FC<PageHeaderProps> = ({ inline, title, subtitle, className }) => {
  const { anchor } = useAppLayoutHeaderAnchor()

  if (!anchor.current) {
    return null
  }

  return (
    <Portal container={anchor.current}>
      <ExtendedPageHeader
        inline={inline}
        className={className}
        title={
          <S.TitleBlock>
            <S.Title variant="h5">
              {!isNil(title) ? title : <Skeleton style={{ width: '10em' }} />}
            </S.Title>
            {!isNil(subtitle) ? <S.Subtitle variant="body2">{subtitle}</S.Subtitle> : null}
          </S.TitleBlock>
        }
      />
    </Portal>
  )
}

PageHeader.displayName = 'PageHeader'
export default PageHeader
